import { UpdateFormButtonsDataRequest } from "./../types";
import { FormsService } from "./../../../services/forms";
import { getChangedSubmitButtonStylesValues } from "../../../helpers/dataManipulations";

export function* updateFormButtonsDataSaga({ payload }: UpdateFormButtonsDataRequest) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedSubmitButtonStylesValues(payload.prevState, payload.currentState),
        });
    } catch (error) {
        console.log("%c Error in update submit button saga", " color:red ", error);
    }
}
